import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getEstimateWithParameters, getEstimationSuburban } from '../../../actions/estimation';
import { TThunkDispatch } from '../../../types/redux';
import { formatEstimationPrices } from '../../../selectors/estimation/selectEstimationPrettyPrices';
import { setNotification } from '../../../actions/notification';
import { getEstimationUpdatedNotificationVarA } from '../../../utils/notifications';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { useScrollToBlock } from '../../Scrolling';
import { setQueryParams, updateUrl } from '../../../actions/page';
import { selectIsSuburban } from '../../../selectors/filters';

export interface IParams {
  handleModalClose(): void;
}

export const useHandleClickModalPrimaryBtn = (params: IParams) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const scrollToBlock = useScrollToBlock();
  const isSuburban = useSelector(selectIsSuburban);
  const { handleModalClose } = params;

  return React.useCallback(async () => {
    /**
     * При ручном изменении фильтров сбрасываем offerId и estimationId, т.к это уже не оценка по офферу в чистом виде
     * */
    dispatch(setQueryParams({ offerId: undefined, estimationId: undefined }));
    dispatch(updateUrl());

    const res = await dispatch(isSuburban ? getEstimationSuburban() : getEstimateWithParameters());

    if (!(res instanceof Error)) {
      handleModalClose();

      if (res.data) {
        const prices = formatEstimationPrices({ ...res.data });

        dispatch(
          setNotification(
            getEstimationUpdatedNotificationVarA({
              price: prices.price,
              onActionClick: () => scrollToBlock(EScrollingBlocks.MarketPrice),
            }),
          ),
        );
      }
    }
  }, [dispatch, handleModalClose, isSuburban, scrollToBlock]);
};
